import Swiper from 'swiper';
import { EffectFade, Thumbs, Navigation } from 'swiper/modules';
import { initDialog } from '../lib/dialog';

function initGallery(parent) {
  const thumbnailsSwiperEl = parent.querySelector(
    '.product-dialog__thumbs-swiper',
  );
  const mainSwiperEl = parent.querySelector('.product-dialog__main-swiper');

  const thumbnailSwiper = new Swiper(thumbnailsSwiperEl, {
    slidesPerView: 5,
    spaceBetween: 12,
    breakpoints: {
      1200: {
        direction: 'vertical',
        spaceBetween: 24,
      },
    },
  });

  new Swiper(mainSwiperEl, {
    modules: [EffectFade, Thumbs],
    loop: true,
    effect: 'fade',
    spaceBetween: 20,
    thumbs: {
      swiper: thumbnailSwiper,
    },
    fadeEffect: {
      crossFade: true,
    },
  });
}

export function initProductDialog(dialogEl) {
  initDialog(dialogEl);

  initGallery(dialogEl);
}

export function initProductDialogs(selector = '.product-dialog') {
  const dialogs = document.querySelectorAll(selector);
  dialogs.forEach((dialog) => initProductDialog(dialog));
}
